import { Webcontent } from "src/app/_utils/_tipos/webcontent";

export class Deposito extends Webcontent
{
    fechaLimite: string;
    tae3MesesAutomatizada: number;
    tae3MesesNoAutomatizada: number;
    tae6Meses: number;
    tae6MesesAutomatizada: number;
    tae6MesesNoAutomatizada: number;
    tae12Meses: number;
    tae12MesesAutomatizada: number;
    tae12MesesNoAutomatizada: number;
    tin3MesesAutomatizada: number;
    tin3MesesNoAutomatizada: number;
    tin6Meses: number;
    tin6MesesAutomatizada: number;
    tin6MesesNoAutomatizada: number;
    tin12Meses: number;
    tin12MesesAutomatizada: number;
    tin12MesesNoAutomatizada: number;
    legalPdf3Meses: string;
    legalPdf6y12Meses: string;
    legalPdf3y6y12Meses: string;
    legalTexto3MesesAutomatizada: string;
    legalTexto3MesesNoAutomatizada: string;
    legalTexto6Meses: string;
    legalTexto6MesesAutomatizada: string;
    legalTexto6MesesNoAutomatizada: string;
    legalTexto12Meses: string;
    legalTexto12MesesAutomatizada: string;
    legalTexto12MesesNoAutomatizada: string;
}